import { render, staticRenderFns } from "./ResumeBuy.vue?vue&type=template&id=51df2c5d&scoped=true"
import script from "./ResumeBuy.vue?vue&type=script&lang=js"
export * from "./ResumeBuy.vue?vue&type=script&lang=js"
import style0 from "./ResumeBuy.vue?vue&type=style&index=0&id=51df2c5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51df2c5d",
  null
  
)

export default component.exports